<app-componente-notificacoes></app-componente-notificacoes>
<div class="container-fluid p-0">
  <app-sidebar>
    <div id="router" class="conteudo" appAutoNoTranslate>
      <router-outlet></router-outlet>
    </div>
  </app-sidebar>
</div>
